// removed by extract-text-webpack-plugin
module.exports = {"root":"_2lxTHnK","banner":"_1W5rITu","topBanner":"_4mj7PzH","topBannerContent":"_1z_D3uA","navigation":"_14aX69k","logo":"l3hfTx4","logoLink":"dT69CyB","user":"_3Uz9XzV","employerSite":"B4zgFXa","employerLink":"_2fQN0hq","locale":"_-vKIc_t","divider":"_2L1R-U2"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Header/Header.less
 ** module id = 714
 ** module chunks = 0
 **/